<!--
  관리자 설정
  관리자/그룹 편집, 관리자 IP 설정 > 관리자 IP 리스트

  @since 2020-02-14
  @author: mk.ko
-->

<template>

  <div class="content-group">
    <template v-if="isPathView">
      <div class="contents-row">
        <div class="portlet">
          <table class="bs-table table-bordered-none">
            <colgroup>
              <col width="320px"/>
              <col width="auto"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="td-head">
                  {{$t('cmn.select')}}
                  <!-- <div class="page-title-1depth"><span class="page-title-1depth-text">선택</span></div> -->
                </td>
                <td>
                  <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                    <q-input v-model="pathName" class="bs bs-q-input bs-q-input-default" style="width:100%;" disable>
                    </q-input>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="contents-clearfix"></div>
    </template>
    <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{$t('sm.adminIpSettings_page_adminIpSetting')}}</span>
        </div>
        <div v-if="adminGeneral.parent_admin_id !== null" class="contents-title-option-group">
          <q-radio @input="onInput" v-model="adminGeneral.admin_ip_inhrit_yn"
                   val="1" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn1')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper">
          </q-radio>
          <q-radio @input="onInput" v-model="adminGeneral.admin_ip_inhrit_yn"
                   val="0" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn2')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper">
          </q-radio>
        </div>
        <!-- 타이틀 끝 -->
        <!-- 상위 옵션 시작 -->
        <div class="page-contents-option-group option-group-sm">
          <!-- 상위 버튼그룹 시작 -->
          <div class="page-contents-btn-group-last">
            <q-btn  color="dark" flat="flat" class="bs bs-q-btn-xs bs-q-btn-flat-type"
              @click="onSuperIpAddForm"
              v-if="fnIsSuper && !isPathView" :disable="isReadOnly">
              <q-icon class="bs-q-btn-icon bs-q-btn-icon-add" >
              </q-icon>
              <span class="bs-q-btn-text">{{$t('sm.adminIpSettings_page_addAdminIp')}}</span>
            </q-btn>
          </div>
          <!-- 상위 버튼그룹 끝 -->
        </div>
        <!-- 상위 옵션 끝 -->
    </div>


    <div class="contents-row">
      <!-- 컨텐츠 패널 시작 -->
      <div class="portlet">

          <!-- 컨텐츠 가로 분할 (필독!! : 부모<div class="row">밑에 자식<div class="bs-row-divide col-xs-6 col-sm-6 col-md-6">로 가로 사이즈 지정) 시작 -->
          <div v-if="adminGeneral.parent_admin_id !== null" class="row bs-multi-select bs-multi-select-default">
            <div class="multi-select-box-group-left col-xs-6 col-sm-6 col-md-6">
              <div v-if="isPathView" class="contents-row marB5">
                <div class="inline-group f-right">
                  <div class="f-left marR5 f14">{{$t('sm.adminIpSettings_page_parentGroup')}}</div>
                  <q-input v-model="adminGeneral.parent_admin_name" class="bs bs-q-sm bs-q-input bs-q-input-default" style="width:190px;" disable/>
                </div>
              </div>
              <div class="contents-row">
                <data-table ref="ldataTable"
                            :fields="fields2"
                            :height="height"
                            :data="adminIpParent"
                            :virtualScrolling="true"
                            :paging="false"
                            :fieldSortable="false"
                            class="bs bs-data-table bs-data-table-basic"
                            pagerFormat=''
                            :rowClick="onIpClick"
                            :rowDoubleClick="onClickArrowRight"
                ></data-table>
              </div>
            </div>

            <div class="multi-select-box-btn-group">
              <div class="multi-select-box-btn select-btn-first-last">
                <q-btn  color="primary" outline="outline" class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line bs-q-btn-multi-select-left"
                        @click="onClickArrowLeft"
                        :disable="isReadOnly || fnIpDisable">
                  <q-icon class="bs-q-btn-icon bs-q-btn-icon-multi-select-box-left-sm"></q-icon>
                </q-btn>
                <q-btn  color="primary" outline="outline" class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line bs-q-btn-multi-select-right-last"
                        @click="onClickArrowRight"
                        :disable="isReadOnly || fnIpDisable">
                  <q-icon class="bs-q-btn-icon bs-q-btn-icon-multi-select-box-right-sm"></q-icon>
                </q-btn>
              </div>
            </div>

            <div class="multi-select-box-group-right col-xs-6 col-sm-6 col-md-6">
              <!-- 상위 옵션 시작 -->
              <div v-if="isPathView" class="page-contents-option-group" style="margin-top: 1px;">
                <!-- 상위 버튼그룹 시작 -->
                <div class="page-contents-btn-group-last">
                  <q-btn  color="dark"
                          flat="flat"
                          class="bs bs-q-btn-xs bs-q-btn-flat-type"
                          @click="onAddIp"
                          :disable="isReadOnly || fnIpDisable">
                    <q-icon class="bs-q-btn-icon bs-q-btn-icon-add"/>
                    <span class="bs-q-btn-text">{{$t('cmn.add')}}</span>
                  </q-btn>
                  <q-btn color="dark"
                         flat="flat"
                         class="bs bs-q-btn-xs bs-q-btn-flat-type"
                         @click="onDelIp"
                         :disable="isReadOnly || fnIpDisable">
                    <q-icon class="bs-q-btn-icon bs-q-btn-icon-delete"/>
                    <span class="bs-q-btn-text">{{$t('cmn.remove')}}</span>
                  </q-btn>
                </div>
              </div>
              <!-- 상위 버튼그룹 끝 -->
              <div class="contents-row">
                <data-table ref="rdataTable"
                            :fields="fields2"
                            :height="height"
                            :data="adminIpCurr"
                            :virtualScrolling="true"
                            :paging="false"
                            :fieldSortable="false"
                            class="bs bs-data-table bs-data-table-basic"
                            pagerFormat=''
                            :disabled="fnIpDisable"
                            :rowDoubleClick="onClickArrowLeft"
                ></data-table>
              </div>
            </div>
          </div>
          <div v-if="adminGeneral.parent_admin_id === null" class="row bs-multi-select bs-multi-select-default">
            <div class="contents-row">
              <div class="col-xs-12 col-sm-12 col-md-12">
              <!-- 상위 옵션 시작 -->
                <div v-if="isPathView" class="page-contents-option-group" style="margin-top: 1px;">
                  <!-- 상위 버튼그룹 시작 -->
                  <div class="page-contents-btn-group-last">
                    <q-btn color="dark"
                           flat="flat"
                           class="bs bs-q-btn-xs bs-q-btn-flat-type"
                           @click="onAddIp"
                           :disable="isReadOnly">
                      <q-icon class="bs-q-btn-icon bs-q-btn-icon-add">
                      </q-icon>
                      <span class="bs-q-btn-text">{{$t('cmn.add')}}</span>
                    </q-btn>
                    <q-btn color="dark"
                           flat="flat"
                           class="bs bs-q-btn-xs bs-q-btn-flat-type"
                           @click="onDelIp"
                           :disable="isReadOnly">
                      <q-icon class="bs-q-btn-icon bs-q-btn-icon-delete">
                      </q-icon>
                      <span class="bs-q-btn-text">{{$t('cmn.remove')}}</span>
                    </q-btn>
                  </div>
                </div>
                <!-- 상위 버튼그룹 끝 -->
                <div class="contents-row">
                  <data-table ref="rdataTable"
                              :fields="fields2"
                              :height="height"
                              :data="adminIpCurr"
                              :virtualScrolling="true"
                              :paging="false"
                              :fieldSortable="false"
                              class="bs bs-data-table bs-data-table-basic"
                              pagerFormat=''
                              :disabled="fnIpDisable"
                  >
                  </data-table>
                </div>
              </div>
            </div>
          </div>
      </div>
      <!-- 컨텐츠 패널 끝 -->
    </div>
    <alert-dialog ref="alertPopup">
    </alert-dialog>

  </div>
</template>
<script>
import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions} = createNamespacedHelpers('system/adminSettings/adminGroupSettings')
import {fnipAddress4, refsFind} from '~/utils/admin-common'
// import iconurl from '~/assets/img/node/icon_router_off.png'
export default {
  name: 'adminIpDatatable',
  data () {
    return {
      // adminIpParentAttr: 1,
      rowSelected: '',
      admin_ip_inhrit_yn: '1',
      refIpSplitPopup: null,
      ipResult: null
    }
  },
  props: {
    fnIsSuper: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '156px'
    },
    isPathView: {
      type: Boolean,
      default: false
    },
    pathName: {
      type: String,
      default: ''
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  created () {},
  computed: {
    ...mapState([
      'adminIpCurr',
      'adminIpParent',
      'adminGeneral',
      'adminIpRange',
      'adminPopupIp'
    ]),
    fields2 () {
      return [
        {
          name: 'admin_ip_exp',
          title: this.$t('cmn.ip'), // '아이피',
          // width: '50%',
          align: 'left',
          itemTemplate (value, row) {
            if (row.admin_ip_mac) {
              return `${value} [${row.admin_ip_mac}]`
            } else {
              return value
            }
          }
        },
        {name: 'admin_ip_desc', title: this.$t('cmn.description'), align: 'left'}
      ]
    },
    fnIpDisable () {
      // 1: 상위, 0:개별
      let ret = false
      if (this.adminGeneral.admin_ip_inhrit_yn === '1') {
        ret = true
      }
      return ret
    },
    isInherit () {
      try {

      } catch (e) {
        return true
      }
    }
  },
  methods: {
    ...mapActions([
      'acsManagersIp',
      'acsCidrToIplist',
      'acsSetErrorMessage',
      'acsPostManagersIpNew',
      'acsManagersIpInhrit',
      'acsManagersIpAdd',
      'acsManagersIpDel',
      'acsManagersGroup'
    ]),
    onSave () {
      this.$emit('onSave')
    },
    onAddIp () {
      this.$emit('emtAddIp')
    },
    onDelIp () {
      this.$emit('emtDelIp')
    },
    // 슈퍼관리자 아이피 추가
    onSuperIpAddForm () {
      if (this.refIpSplitPopup === undefined) {
        return false
      }
      const $ipPopup = this.refIpSplitPopup
      this.adminIpRange.start_ip = ''
      this.adminIpRange.end_ip = ''
      this.adminIpRange.ip_exp = ''
      this.adminPopupIp.start_ip = ''
      this.adminPopupIp.end_ip = ''
      this.adminPopupIp.ip_exp = ''
      this.adminPopupIp.ip_desc = ''
      $ipPopup.datatable = []
      $ipPopup.ipSuperAddMode = true
      $ipPopup.titleName = this.$t('sm.adminIpSettings_page_addIp')
      $ipPopup.show()
    },
    async onInput () {
      const payload = {
        admin_id: this.adminGeneral.admin_id,
        params: {
          admin_ip_inhrit_yn: parseInt(this.adminGeneral.admin_ip_inhrit_yn)
        }
      }
      const res = await this.acsManagersIpInhrit(payload)
      if (res.code === 'ok') {
        if (typeof this.$parent.ipOnlyApplyOk !== 'undefined') {
          this.$parent.ipOnlyApplyOk = true
        }
        const result = await this.acsManagersGroup(payload.admin_id)
        if (result !== 'ok') {
          this.$refs.alertPopup.show(result.errors)
        }
      }
    },
    onIpClick (data) {
      if (this.isReadOnly) {
        return
      }
      if (this.fnIpDisable) {
        return false
      }
      if (typeof this.refIpSplitPopup === 'undefined' || this.refIpSplitPopup === null) {
        return false
      }
      const $ipPopup = this.refIpSplitPopup
      if ($(data.event.target).is('.devTypeIpClick')) {
        const ip = fnipAddress4(data.item.admin_ip_exp)
        this.adminIpRange.start_ip = ip.startIp
        this.adminIpRange.end_ip = ip.endIp
        this.adminIpRange.ip_exp = `${ip.startIp}-${ip.endIp}`
        this.adminPopupIp.start_ip = ip.startIp
        this.adminPopupIp.end_ip = ip.endIp
        this.adminPopupIp.ip_exp = `${ip.startIp}-${ip.endIp}`
        this.adminPopupIp.ip_desc = data.item.admin_ip_desc
        $ipPopup.datatable = []
        $ipPopup.ipSuperAddMode = false
        $ipPopup.titleName = this.$t('sm.adminIpSettings_page_separateAdminIp')
        $ipPopup.$refs.groupIpLayerPopUp.show()
      }
    },
    // 아이피 정보(상위속성) 개별속성으로
    async onClickArrowRight () {
      if (this.isReadOnly) {
        return
      }

      if (this.adminGeneral.admin_ip_inhrit_yn === '1') {
        return false
      }
      const selectedItems = this.$refs.ldataTable.jsGridExec('option', 'getRowSelectionItem')
      if (selectedItems.length <= 0) {
        this.acsSetErrorMessage(this.$t('msg.updateSelect'))
        return false
      }
      if (selectedItems.length !== 1) {
        this.acsSetErrorMessage(this.$t('msg.selectIpOne'))
        return false
      }
      const payload = {
        admin_id: this.adminGeneral.admin_id,
        params: {
          admin_ip_desc: selectedItems[0].admin_ip_desc,
          admin_ip_exp: selectedItems[0].admin_ip_exp,
          admin_ip_mac: selectedItems[0].admin_ip_mac
        }
      }
      const res = await this.acsManagersIpAdd(payload)
      if (res.code === 'ok') {
        // await this.acsManagersIp(payload.admin_id)
        if (typeof this.$parent.ipOnlyApplyOk !== 'undefined') {
          this.$parent.ipOnlyApplyOk = true
        }
        const result = await this.acsManagersGroup(payload.admin_id)
        if (result !== 'ok') {
          this.$refs.alertPopup.show(result.errors)
        }
      }
    },
    // 개별속성 아이피 제거
    async onClickArrowLeft () {
      if (this.isReadOnly) {
        return
      }

      if (this.adminGeneral.admin_ip_inhrit_yn === '1') {
        return false
      }
      const selectedItems = this.$refs.rdataTable.jsGridExec('option', 'getRowSelectionItem')
      if (selectedItems.length <= 0) {
        this.acsSetErrorMessage(this.$t('msg.selectDeleteContents'))
        return false
      }
      if (selectedItems.length > 1) {
        this.acsSetErrorMessage(this.$t('msg.updateSelectOne'))
        return false
      }
      const payload = {
        admin_ip_id: selectedItems[0].admin_ip_id
      }
      const res = await this.acsManagersIpDel(payload)
      if (res.code === 'ok') {
        // await this.acsManagersIp(this.adminGeneral.admin_id)
        const result = await this.acsManagersGroup(this.adminGeneral.admin_id)
        if (result !== 'ok') {
          this.$refs.alertPopup.show(result.errors)
        }
      }
    }
  },
  watch: {},
  mounted () {
    this.$nextTick(() => {
      if (typeof this.$refs.rdataTable !== 'undefined') {
        this.$refs.rdataTable.render()
      }
      this.refIpSplitPopup = refsFind(this, 'refIpSplitPopup')
    })
  }
}
</script>
<style>
  .rowSelected {
    background: #498dda
  }
</style>

